import { createReducer, updateState } from 'redux/handlers'
import types from './types'

const initialState = {
  header: {},
  processesList: [],
  currentProcess: '',
  currentTab: 'processes',
  categoriesList: [],
  labelsList: [],
  deployLoading: false,
  deployError: null,
  modalLoading: false,
  modalError: null,
  loading: true,
  error: null
}

const getSmartchat = (state, action) => updateState(state, action.payload)

const updateCurrentProcess = (state, action) => updateState(state, { currentProcess: action.payload })

const updateCurrentTab = (state, action) => updateState(state, { currentTab: action.payload })

const updateCategoriesList = (state, action) => updateState(state, { categoriesList: action.payload })

const updateLabelsList = (state, action) => updateState(state, { labelsList: action.payload })

const updateDeployLoading = (state, action) => updateState(state, { deployLoading: action.payload })

const updateDeployError = (state, action) => updateState(state, { deployError: action.payload })

const updateModalLoading = (state, action) => updateState(state, { modalLoading: action.payload })

const updateModalError = (state, action) => updateState(state, { modalError: action.payload })

const updateLoading = (state, action) => updateState(state, { loading: action.payload })

const updateError = (state, action) => updateState(state, { error: action.payload })

export default createReducer(initialState, {
  [types.SMARTCHAT_HEADER_INITIAL_DATA]:            getSmartchat,
  [types.SMARTCHAT_HEADER_UPDATE_CURRENT_PROCESS]:  updateCurrentProcess,
  [types.SMARTCHAT_HEADER_UPDATE_CURRENT_TAB]:      updateCurrentTab,
  [types.SMARTCHAT_HEADER_UPDATE_CATEGORIES_LIST]:  updateCategoriesList,
  [types.SMARTCHAT_HEADER_UPDATE_LABELS_LIST]:      updateLabelsList,
  [types.SMARTCHAT_HEADER_UPDATE_DEPLOY_LOADING]:   updateDeployLoading,
  [types.SMARTCHAT_HEADER_UPDATE_DEPLOY_ERROR]:     updateDeployError,
  [types.SMARTCHAT_HEADER_UPDATE_MODAL_LOADING]:    updateModalLoading,
  [types.SMARTCHAT_HEADER_UPDATE_MODAL_ERROR]:      updateModalError,
  [types.SMARTCHAT_HEADER_UPDATE_LOADING]:          updateLoading,
  [types.SMARTCHAT_HEADER_UPDATE_ERROR]:            updateError
})
